import React from "react";
import FieldBridge from "./FieldBridge";
import FieldErrorIcon from "./FieldErrorIcon";
import { fieldErrorMessages } from "./fieldErrorMessages";
import { FormControl, InputAdornment } from "@mui/material";
import { SelectWithInput } from "./Select/SelectInput";
import FormInputOuter from "./FormInputOuter";
import { StyledTextField } from "customStyled";
import { withTrimHandler } from "utils/reactiveFormFunc";
import FormLabel from "./FormLabel";
import { useTranslation } from "react-i18next";
import i18n from "i18n";
import { autocompleteToken } from "utils";

const titleOption = [
  {
    value: "dr",
    get label() { return i18n.t("form:dr"); },
  },
  {
    value: "mr",
    get label() { return i18n.t("form:mr"); },
  },
  {
    value: "miss",
    get label() { return i18n.t("form:miss"); },
  },
  {
    value: "mrs",
    get label() { return i18n.t("form:mrs"); },
  },
];

const NameWithTitle = (props) => {
  const { t } = useTranslation("form");
  const { id, placeholder, autoComplete, label } = props;
  return (
    <FormInputOuter {...props}>
      <FieldBridge
        name={id}
        render={({ handler, pending, touched, invalid, errors }) => {
          const isError = touched && invalid;
          const messages = isError ? fieldErrorMessages({ errors, label: label || t("firstName") }) : [];
          return (
            <FormControl error={isError}>
              <FormLabel label={t("title")} required={true} id={id} />
              <StyledTextField
                id={id}
                height={44}
                name={id}
                placeholder={placeholder}
                autoComplete={autocompleteToken(autoComplete)}
                {...withTrimHandler(handler, "text")}
                sx={{
                  marginTop: "5px",
                  height:44,
                  "& .MuiFormControl-root": {
                    mr: 0,
                    "& .MuiInputBase-root": {
                      "&::before": {
                        borderBottomWidth: 0,
                      },
                      "&::after": {
                        borderBottomWidth: 0,
                      },
                      "& .MuiSelect-select": {
                        paddingBottom: 0,
                        paddingLeft: 0,
                      },
                    },
                    minWidth: "50px",
                  },
                  "& input ": {
                    padding: "0 9px",
                    fontSize: "16px",
                    fontWeight: 400,
                    lineHeight: "24px",
                    height: "inherit",
                  },
                  pl: 0,
                }}
                endAdornment={
                  <InputAdornment position="end">
                    {isError ? <FieldErrorIcon messages={messages} /> : null}
                  </InputAdornment>
                }
                startAdornment={
                  <InputAdornment position="start">
                    <SelectWithInput
                      placeholder=""
                      name="prefix"
                      id="prefix"
                      variant="standard"
                      autoComplete="honorific-prefix"
                      helperText={null}
                      optionList={titleOption}
                    />
                  </InputAdornment>
                }
              />
            </FormControl>
          );
        }}
      />
    </FormInputOuter>
  );
};

export default NameWithTitle;
